import { z } from "zod";
import {
  INCIDENT_TYPE,
  DESCRIPTION,
  INCIDENT_CATEGORY,
  ASSIGN_TO,
  ATTACHMENTS,
  COMMENTS,
  COMMON_AREA,
  PRIORITY,
  PROPERTY_ID,
  PROPERTY_SPECIFIC,
  REPORTEE,
  RESPONSIBLE,
  STATUS,
  ASSIGNMENT_DATE,
} from "./consts";

export const bomSchema = z.object({
  [INCIDENT_TYPE]: z.string().min(1, "This field is required."),
  [INCIDENT_CATEGORY]: z.string().min(1, "This field is required."),
  [PROPERTY_SPECIFIC]: z.boolean().optional(),
  [COMMON_AREA]: z.boolean().optional(),
  [ASSIGN_TO]: z.string().optional(),
  [RESPONSIBLE]: z.string().optional(),
  [REPORTEE]: z.any(),
  [ASSIGNMENT_DATE]: z.string().optional(),
  [PRIORITY]: z.string().min(1, "This field is required."),
  [STATUS]: z.string().min(1, "This field is required."),
  [ATTACHMENTS]: z.any().optional(),
  [DESCRIPTION]: z.string().optional(),
  [PROPERTY_ID]: z.string().optional(),
  [COMMENTS]: z.string().min(1, "This field is required."),
});

export type bomFormValues = z.infer<typeof bomSchema>;

export const ownerSchema = z.object({
  [INCIDENT_TYPE]: z.string().min(1, "This field is required."),
  [INCIDENT_CATEGORY]: z.string().min(1, "This field is required."),
  [PROPERTY_SPECIFIC]: z.boolean().optional(),
  [COMMON_AREA]: z.boolean().optional(),
  [ASSIGN_TO]: z.string().optional(),
  [RESPONSIBLE]: z.string().optional(),
  [REPORTEE]: z.any(),
  // [ASSIGNMENT_DATE]: z.string().optional(),
  [PRIORITY]: z.string().optional(),
  [STATUS]: z.string().optional(),
  [ATTACHMENTS]: z.any().optional(),
  [DESCRIPTION]: z.string().optional(),
  [PROPERTY_ID]: z.string().optional(),
  [COMMENTS]: z.string().optional(),
});

export type ownerFormValues = z.infer<typeof ownerSchema>;
